import { useAuth } from '@clerk/vue';

export default (router) => {
  /* eslint-disable consistent-return -- Vue Router next() must be called exactly once; returning changes behavior */
  router.beforeEach((to, from, next) => {
    const { isSignedIn } = useAuth();

    const isAnonymousRoute = to.matched.some((record) => {
      // Explicitly block home unless marked anonymous
      if (record.name === 'home') return false;
      return record.meta.anonymous === true;
    });

    // Allow Clerk sign-in route
    if (to.path === '/sign-in') {
      return next();
    }

    // Redirect unauthenticated users from protected routes
    if (!isSignedIn.value && !isAnonymousRoute && to.name !== 'login' && to.name !== 'home') {
      return next({
        name: 'login',
        query: { returnPath: to.fullPath },
      });
    }

    next();
  });
  /* eslint-enable consistent-return */
};
